import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from './Chip';
import Eyebrow from './Eyebrow';

const EVIDENCE_VARIANT = {
  Explicit: 'success',
  Implied:  'warning',
  Possible: 'neutral',
};

// Spec §8.12 — page-3 full match card with quote block, evidence + offering
// chips, and a recommended next step.
const FullMatchCard = ({ match }) => (
  <View wrap={false} style={{
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    borderRadius: 6,
    borderWidth: 0.6,
    borderColor: colors.hair,
    overflow: 'hidden',
    marginBottom: space.md,
  }}>
    <View style={{ width: 4, backgroundColor: colors.teal }} />
    <View style={{ flex: 1, padding: space.lg }}>
      <Text style={[type.cardTitle, { color: colors.ink }]}>{match.title}</Text>

      {match.quote && (
        <View style={{
          flexDirection: 'row',
          marginTop: space.md,
          backgroundColor: colors.tealPale,
          borderRadius: 4,
          padding: space.md,
        }}>
          <View style={{ width: 3, backgroundColor: colors.teal, marginRight: space.md, borderRadius: 2 }} />
          <View style={{ flex: 1 }}>
            <Text style={[type.body, { color: colors.ink, fontStyle: 'italic', fontWeight: 500 }]}>
              &ldquo;{match.quote}&rdquo;
            </Text>
            {match.attribution && (
              <Text style={[type.caption, { color: colors.teal, fontWeight: 700, marginTop: 6, letterSpacing: 0.3 }]}>
                — {match.attribution}
              </Text>
            )}
          </View>
        </View>
      )}

      <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: space.md, gap: 6 }}>
        {match.evidence && (
          <Chip variant={EVIDENCE_VARIANT[match.evidence] || 'neutral'}>{match.evidence}</Chip>
        )}
        {(match.offerings || []).map((o, i) => (
          <Chip key={i}>{o}</Chip>
        ))}
      </View>

      {match.nextStep && (
        <View style={{ marginTop: space.md }}>
          <Eyebrow>Recommended Next Step</Eyebrow>
          <Text style={[type.body, { color: colors.ink, marginTop: 4 }]}>{match.nextStep}</Text>
        </View>
      )}
    </View>
  </View>
);

export default FullMatchCard;
